import m from '@bitstillery/mithril'
import {MithrilComponent} from '@bitstillery/mithril'
import {Button} from '@bitstillery/common/components/portal'
import {$t} from '@bitstillery/common/app'

/**
 * Body of a page that resolves to nothing. Deliberately carries no sentence of its own: the hero above
 * it already renders `page.404.title` / `page.404.description`, and repeating either on the same screen
 * reads as a stutter. What's left is the status numeral and the way out.
 *
 * The static twin of this page — served by the SSR route gate without rendering the app at all — lives
 * in `src/error_page.ts`; the two are meant to look like the same page with and without its chrome.
 */
export class CmsNotFound extends MithrilComponent {
    view(): m.Children {
        return (
            <div className='c-cms-not-found'>
                <div className='status-code' aria-hidden='true'>
                    404
                </div>
                <Button icon='home' link='/' text={$t('breadcrumbs.home')} size='l' type='brand' variant='action' />
            </div>
        )
    }
}
